import { makeStyles } from '@material-ui/styles'

export default makeStyles(({ spacing }) => ({
  container: {
    fontSize: '3rem',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',
    boxShadow: 'none',
    padding: 0,
    paddingTop: 0,
    margin: 0,
    marginTop: spacing(8),

    '& .MuiTypography-root': {
      fontWeight: 'normal',
    },
  },
  title: {
    color: '#000000',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    marginBottom: spacing(4),
    textAlign: 'left',
    marginLeft: '5px',
  },
  button: {
    height: spacing(40),
    marginTop: '5px',
    marginLeft: '5px',
    fontWeight: 'normal',
    fontSize: '16px',
    border: 0,
    color: '#000000',

    '&:hover': {
      border: 0,
      backgroundColor: 'none',
    },
  },
  subTitle: {
    fontSize: '12px',
    paddingLeft: '24px',
  },
}))
